// extracted by mini-css-extract-plugin
export default {"BlankslateContainer":"Blankslate-module__BlankslateContainer__DBF97zh"};